import { Outlet } from 'react-router';

import Map from '@/components/map/Map';
import { TargetSelectorProvider } from '@/contexts/TargetSelectorContext';
import { AppErrorBoundary } from '@/shared/ui/app-error-boundary/AppErrorBoundary';

export function RoutesLayout() {
  return (
    <TargetSelectorProvider>
      <Outlet />
      <AppErrorBoundary boundaryId="routes-map">
        <Map />
      </AppErrorBoundary>
    </TargetSelectorProvider>
  );
}
